import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import { ROLE, isDashboardRole } from "../helpers/utils";
import { RedirectLoginPermissionArray } from "../helpers/permissionModule";

interface FeatureGuardProps {
  isEnabled: boolean;
  children: React.ReactNode;
}

export const FeatureGuard: React.FC<FeatureGuardProps> = ({
  isEnabled,
  children,
}) => {
  const { user } = useSelector((state: RootState) => state.auth);

  if (isEnabled) {
    return <>{children}</>;
  }

  const roleKey = user?.role?.key || "";
  const roleName = String(user?.role?.name || "").toLowerCase();
  const isAttendanceTabletRole =
    roleKey === ROLE.ATTENDANCE_TABLET ||
    roleKey === "attendance-tablet" ||
    roleName.includes("attendance tablet") ||
    roleName.includes("attendance-tablet");

  if (isAttendanceTabletRole) {
    return <Navigate to="/face-scanner" replace />;
  }

  // If the feature is disabled, calculate the best fallback route for the user
  const findRedirectPath: any =
    user?.role?.key === ROLE.ADMIN
      ? RedirectLoginPermissionArray?.find((elem) => !elem?.disabled && (elem?.name !== "dashboard" || isDashboardRole(user?.role || user?.role?.key)))
      : RedirectLoginPermissionArray?.find(
          (ele: any) =>
            !ele?.disabled &&
            (ele?.name !== "dashboard" || isDashboardRole(user?.role || user?.role?.key)) &&
            user?.role?.permission?.some((per: any) => per?.name === ele?.name),
        );

  const fallbackPath = findRedirectPath?.path || "/login";

  return <Navigate to={fallbackPath} replace />;
};
